export const MARKETING_URL = import.meta.env.VITE_MARKETING_URL as string;
export const TURNSTILE_SITE_KEY = import.meta.env.VITE_TURNSTILE_SITE_KEY as string | undefined;
